import { render, staticRenderFns } from "./DefaultSidebarDesktop.vue?vue&type=template&id=7b0f79eb"
import script from "./DefaultSidebarDesktop.vue?vue&type=script&lang=ts"
export * from "./DefaultSidebarDesktop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports